export const FETCH_CURRENT_PAGE = 'FETCH_CURRENT_PAGE'
export const FETCH_DATATRANSFERS_REQUEST = 'FETCH_DATATRANSFERS_REQUEST'
export const FETCH_DATATRANSFERS_SUCCESS = 'FETCH_DATATRANSFERS_SUCCESS'
export const FETCH_DATATRANSFERS_FAILED = 'FETCH_DATATRANSFERS_FAILED'
export const FETCH_DATATRANSFERS_RESOURCEID_REQUEST = 'FETCH_DATATRANSFERS_RESOURCEID_REQUEST'
export const FETCH_DATATRANSFERS_RESOURCEID_SUCCESS = 'FETCH_DATATRANSFERS_RESOURCEID_SUCCESS'
export const FETCH_DATATRANSFERS_RESOURCEID_FAILED = 'FETCH_DATATRANSFERS_RESOURCEID_FAILED'
